import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppSharedModule } from 'app/app-shared.module';
import { GroupRouteGuardService } from 'app/services/group-route-guard.service';
import { ConfigurationSharedModule } from '../configuration/configuration-shared.module';
import {
  AuthGuardService,
  NotExecutiveGuardService,
} from '../../providers/bridge-api/auth.service';
import { FieldAliasSelectorComponent } from './field-alias-selector/field-alias-selector.component';
import { FieldBucketsComponent } from './field-buckets/field-buckets.component';
import { FieldCreateModalComponent } from './field-create-modal/field-create-modal.component';
import { FieldListComponent } from './field-list/field-list.component';
import { FieldListFilterComponent } from './field-list-filter/field-list-filter.component';
import { FieldViewComponent } from './field-view/field-view.component';
import { hasFieldViewUnsavedChangesGuard } from './field-view/field-view.guard';

@NgModule({
  imports: [
    AppSharedModule,
    RouterModule.forRoot(
      [
        {
          canActivate: [AuthGuardService, NotExecutiveGuardService, GroupRouteGuardService],
          path: 'groups/:groupId/fields',
          component: FieldListComponent,
          children: [
            {
              canActivate: [AuthGuardService],
              path: ':fieldId',
              component: FieldViewComponent,
              canDeactivate: [hasFieldViewUnsavedChangesGuard],
            },
          ],
        },
      ],
      {}
    ),
    ConfigurationSharedModule,
    FieldBucketsComponent,
    FieldListFilterComponent,
    FieldListComponent,
    FieldCreateModalComponent,
    FieldAliasSelectorComponent,
    FieldViewComponent,
  ],
  declarations: [],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FieldModule {}
